module.exports = __webpack_public_path__ + "img/builder-23.2d0c6c2d.jpg";